import React from 'react';
import ProductService from '../services/product';
import $ from 'jquery';
import AuthorizationCheck from '../auth/authorizationCheck';
import { Modal } from 'react-bootstrap';
import UpdateProduct from './updateProduct';
import Utility from '../utilities/utility';
import placeholder from '../placeholder.png';

class Products extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            productList: [],
            currentUserRole: '',
            showEditProduct: false,
            showDeleteProduct: false,
            timeoutId: null,
        }
    }

    componentDidMount() {

        this.findProducts();
    }

    showDeleteProductForm = (productId, e) => {

        e.preventDefault();

        $('#selectedProductId').val(productId);

        this.setState({

            showDeleteProduct: true
        });

    }

    hideDeleteProductForm = () => {

        this.setState({

            showDeleteProduct: false
        });

    }

    showEditProductForm = () => {

        this.setState({

            showEditProduct: true
        });

    }

    hideEditProductForm = () => {

        this.setState({

            showEditProduct: false
        });

    }



    findProducts = async () => {

        let name = $('#name').val();
        let model = $('#model').val();
        let brand = $('#brand').val();
        let color = $('#color').val();
        let size = $('#size').val();
        let cpid = $('#cpid').val();

        try {

            const response = await ProductService.adminProductList(name, model, brand, size, color, cpid);

            if (response.ok) {

                this.setState({
                    productList: await response.json()
                })
            }


        } catch (error) {
            console.log(error);
        }

    }

    searchProduct = () => {

        let timer;

        clearTimeout(this.state.timeoutId);

        timer = setTimeout(() => {
            this.findProducts();
        }, 1500);

        this.setState({ timeoutId: timer })
    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    ediProduct = (productId, e) => {

        e.preventDefault();

        $('#selectedProductId').val(productId);

        this.showEditProductForm();
    }

    updateProduct = async (productId, selectedFile, base64Image) => {

        console.log(base64Image);

        let name = $('#uname').val();
        let model = $('#umodel').val();
        let brand = $('#ubrand').val();
        let color = $('#color').val();
        let size = $('#usize').val();
        let cbm = $('#cbm').val();
        let price = $('#price').val();
        let qtyInBox = $('#qtyInBox').val();
        let weight = $('#weight').val();
        let supplierUniqueId = $('#supplierUniqueId').val();

        let customerPrice = $('#customerPrice').val();




        try {

            if (Utility.isEmpty(name)) {

                $('.messageHolder').html(

                    '<div class="alert alert-danger ms-alert">Le nom du produit doit etre fourni</div>'
                );

                $('.ms-alert').delay(3000).fadeOut('slow');

                return;
            }

            const response = await ProductService.updateProduct(productId, name, model, brand, size, color,
                cbm, qtyInBox, weight, supplierUniqueId, price, customerPrice);

            if (response.ok) {

                let products = this.state.productList;

                let productResponse = await response.json();

                let productList = products.map(product => product.id == productId ? productResponse : product);



                this.setState({ productList: productList });

                $('.messageHolder').html(

                    '<div class="alert alert-success ms-alert">Produit mis a jour</div>'
                );

                $('.ms-alert').delay(3000).fadeOut('slow');

            }

        } catch (error) {

            console.log(error);

            $('.messageHolder').html(

                '<div class="alert alert-danger ms-alert">Problem lors du mis a jour du produit</div>'
            );

            $('.ms-alert').delay(3000).fadeOut('slow');
        }
    }

    deleteProduct = async () => {

        try {

            let productId = $('#selectedProductId').val();

            const response = await ProductService.deleteProduct(productId);

            if (response.ok) {


                let products = this.state.productList.filter(product => product.id != productId);

                this.setState({
                    productList: products,
                    showDeleteProduct: false
                });



                return;
            }

            $('.deleteMessage').html(

                '<div class="alert alert-danger ms-alert">Problem lors de l operation</div>'
            );

            $('.ms-alert').delay(3000).fadeOut('slow');

        } catch (error) {

            $('.deleteMessage').html(

                '<div class="alert alert-danger ms-alert">Problem lors de l operation</div>'
            );

            $('.ms-alert').delay(3000).fadeOut('slow');
        }



    }

    updateProductImage = (updateProduct) => {

        let products = this.state.productList;

                

                let productList = products.map(product => product.id == updateProduct.id ? updateProduct : product);



                this.setState({ productList: productList });

    }


    render() {



        const productList = this.state.productList;

        return (


            <div className="container">

                <AuthorizationCheck accessLevel='ADMIN' userRole={this.setRole} />

                <input type='hidden' id='selectedProductId' />

                <Modal show={this.state.showEditProduct}>
                    <Modal.Header closeButton onHide={this.hideEditProductForm}>Mis a jour du Produit</Modal.Header>
                    <Modal.Body>



                        <UpdateProduct productService={ProductService} updateProduct={this.updateProduct} updateProductImage = {this.updateProductImage} />



                    </Modal.Body>

                </Modal>

                <Modal show={this.state.showDeleteProduct}>
                    <Modal.Header closeButton onHide={this.hideDeleteProductForm}>Mis a jour du Produit</Modal.Header>
                    <Modal.Body>

                        <div className='deleteMessage'></div>

                        <p className='text-center'>Voulez vous supprimer ce produit?</p>

                        <button className='btn btn-danger full-width' onClick={this.deleteProduct}>Supprimer</button>


                    </Modal.Body>

                </Modal>

                <div className="supplier-wrapper mt-4">

                    <h2 className="text-center">List de Produits</h2>


                    <div className="form-wrapper">
                        <div className="row">
                            <div className="col">


                                <div className="form-group">
                                    <input className="form-control" id="name" placeholder="Nom" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="model" placeholder="Model" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">

                                <div className="form-group">
                                    <input className="form-control" id="brand" placeholder="Marque" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="size" placeholder="Numero" onKeyUp={this.searchProduct} />
                                </div>
                            </div>

                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="cpid" placeholder="CPID" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                        </div>




                    </div>

                    <div className="card card-default mt-2 bg-primary text-white">



                        <div className="card-body">
                            <div className="row">
                                <div className="col">Image</div>
                                <div className="col-md-3">Description</div>
                                <div className="col">CBM&POIDS&PRIX</div>
                                <div className="col">Qté/Carton</div>

                                <div className="col"></div>


                            </div>
                        </div>

                    </div>

                    {productList.length > 0 && productList.map(product =>

                        <div className="card card-default mt-2" key={product.id}>

                            <div className="card-body">
                                <div className="row">
                                    <div className="col">
                                        <img
                                            style={{width: '200px', height: 'auto'}}
                                            src={product.images ? product.images[0].fullUrl: ''}
                                            alt="Product"
                                            onError={(e) => {
                                                e.target.onerror = null; // prevent infinite loop
                                                e.target.src = placeholder;
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <div>{product.name} {product.model} {product.brand} {product.color} {product.size}</div>
                                        <div className='text-primary mt-2'> CPID: {product.supplierUniqueId} </div>
                                    </div>




                                    <div className="col">
                                        <div>CBM: {product.cbm}</div>
                                        <div>Poids: {product.weight}</div>
                                        <div>Prix: {product.price}</div>
                                        <div>Prix Client: {product.customerPrice}</div>
                                    </div>
                                    <div className="col">{product.boxQuantity}</div>

                                    <div className="col">
                                        <div><button className='btn btn-primary btn-sm' onClick={(e) => this.ediProduct(product.id, e)}>Edit</button></div>
                                        <div><button className='btn btn-danger btn-sm mt-2' onClick={(e) => this.showDeleteProductForm(product.id, e)}>X</button></div>
                                        <div><a href={'/admin/orders?productId=' + product.id}><button className='btn btn-primary mt-2 btn-sm'>Commandes</button></a></div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    )}

                </div>
            </div>



        );


    }
}

export default Products;